/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { LIST_REPORTB } from "./actionTypes"
import { listReportBError, listReportBSuccess } from "./actions"

//Include Both Helper File with needed methods
import { reportBNewApi } from "../../../helpers/backend_helper"

function* list(request) {
  try {
    const response = yield call(reportBNewApi, request.payload.form)
    if (response === undefined) throw new Error("API error")
    if (response.length === undefined) throw new Error(response)
    yield put(listReportBSuccess(response))
  } catch (error) {
    console.log(error.message)
    yield put(listReportBError(error.message))
  }
}

function* reportBListSaga() {
  yield takeEvery(LIST_REPORTB, list)
}

export default reportBListSaga
